// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"97b6ac60","787":"cdf22c59"}[chunkId] + ".chunk.js";
};